import React, { useEffect, useRef, useState, useContext } from "react";
import styles from "./ModalUploadFileV3.module.css";
import Input from "../input/Input";
import Button from "../button/Button";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { FaArrowDown, FaMinus } from "react-icons/fa";
import { CurrentUserContext } from "../../../App";
import { ClipLoader } from "react-spinners";

function ModalUploadFileV3({
  show,
  onSubmit,
  onClose,
  title,
  placeholder,
  initialData,
}) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const inputFileRef = useRef(null);
  const [file, setFile] = useState(null);
  const [inputValue, setInputValue] = useState(
    initialData?.document_name || "",
  );
  const [disabledButton, setDisabledButton] = useState(false);
  const [iconOpen, setIconOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setInputValue(initialData?.document_name || "");
      setFile(null);
    }
  }, [show, initialData]);

  const inputFileChange = (event) => {
    let fileObj = event.target.files[0];
    setIconOpen(true);
    setFile(fileObj);
    setIconOpen(false);
  };
  const submitButton = () => {
    if (!file) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกไฟล์" });
      return;
    }
    setIconOpen(false);

    onSubmit({
      file: file,
      inputValue: inputValue,
    });
  };
  return (
    <>
      {show ? (
        <div className={styles.overlay}>
          <div className={styles.modalController}>
            <div className={styles.closeButton}>
              <img
                onClick={() => {
                  onClose();
                }}
                src={require("../../../asset/icon/close-icon.svg").default}
                alt="icon"
              ></img>
            </div>
            <div className={styles.contentModal}>
              <div className={styles.title}>{title || "-"}</div>

              {initialData?.fileUrl && (
                <div className="w-full flex justify-center items-center">
                  <a
                    href={initialData.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-link"
                  >
                    ดาวน์โหลดไฟล์เดิม
                  </a>
                </div>
              )}

              <div className={styles.container}>
                <Input
                  value={inputValue}
                  setValue={setInputValue}
                  placeholder={placeholder || "ระบุ"}
                />
                <input
                  accept=".pdf"
                  type={"file"}
                  ref={inputFileRef}
                  onChange={(e) => {
                    inputFileChange(e);
                  }}
                  style={{ display: "none" }}
                ></input>
                <div className="flex flex-col justify-center items-center border-[1px] border-solid border-[#E0DFE2] rounded-[6px]">
                  <Button
                    onClick={() => {
                      inputFileRef.current.click();
                    }}
                    style={{
                      gridGap: 10,
                      width: "300px",
                      padding: "23px 34px",
                      height: "125px",
                      background: "#FFFFFF 0% 0% no-repeat padding-box",
                      border: "1px dashed #AEE7E8",
                      borderRadius: "14px",
                      opacity: 1,
                      color: "#06A7AD",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexFlow: "column",
                      position: "relative",
                    }}
                  >
                    {iconOpen ? (
                      <ClipLoader
                        size={20}
                        color="#06A7AD"
                        className="absolute top-2 right-2"
                      />
                    ) : (
                      <FaArrowDown
                        className="w-[20px] h-[20px] text-[#06A7AD] absolute top-2 right-2 hover:bg-[#BFE9EA] rounded-[100%] p-[1px]"
                        onClick={(e) => {
                          e.stopPropagation();
                          submitButton();
                        }}
                      />
                    )}
                    {file ? (
                      file.name
                    ) : (
                      <>
                        <CloudArrowUpIcon className="text-[#06A7AD] w-[45px] h-[31px]" />
                        <div>วางไฟล์ไว้ที่นี่หรืออัพโหลดไฟล์</div>
                      </>
                    )}
                  </Button>
                </div>
                <div className={styles.fileName}>{file ? file.name : "-"}</div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    disabled={disabledButton}
                    style={{ width: "100px" }}
                    onClick={() => {
                      // setDisabledButton(true)
                      submitButton();
                    }}
                  >
                    บันทึก
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default ModalUploadFileV3;
